var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcode-stream',{directives:[{name:"show",rawName:"v-show",value:(_vm.qrcode),expression:"qrcode"}],attrs:{"camera":_vm.camera,"torch":_vm.torchActive},on:{"decode":_vm.onDecode,"init":_vm.onInit}},[_c('div',[_c('div',{staticClass:"qr-scanner"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f1765b36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/qrcode.vue
// module id = null
// module chunks = 